import styled, { css } from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, spacing, fontSizes, fontWeights } from 'ui/theme';
import { TEMPLATE_PREVIEW_SIZE_VARIANTS } from '../../constants';

const CONTAINER_SIZE_VARIANTS = {
  [TEMPLATE_PREVIEW_SIZE_VARIANTS.CARD]: css`
    transform: ${({ showInAppInbox }) =>
      showInAppInbox ? 'scale(0.75) translateY(35%)' : 'scale(0.275)'};
  `,
  [TEMPLATE_PREVIEW_SIZE_VARIANTS.THUMBNAIL]: css`
    transform: ${({ showInAppInbox }) =>
      showInAppInbox ? 'scale(0.15) translateY(25%)' : 'scale(0.075)'};
  `,
  [TEMPLATE_PREVIEW_SIZE_VARIANTS.SMALL_THUMBNAIL]: css`
    transform: ${({ showInAppInbox }) =>
      showInAppInbox ? 'scale(0.15) translateY(25%)' : 'scale(0.045)'};
  `,
};

export const Container = styled.div`
  position: absolute;
  transition: all 1s ease;
  ${({ size }) => CONTAINER_SIZE_VARIANTS[size] || ''}
`;

export const InboxContainer = styled.div`
  position: absolute;
  top: ${pxToRem(50)};
  left: ${pxToRem(50)};
  width: 75%;
`;

export const InboxHeader = styled.p`
  text-align: center;
  font-size: ${fontSizes.s20};
`;

export const InboxContent = styled.div`
  border-bottom: ${spacing.eighth} solid ${colors.grey15};
  border-top: ${spacing.eighth} solid ${colors.grey15};
  display: flex;
  justify-content: space-between;
  padding: ${spacing.base};
  position: relative;
`;

export const InboxContentTitle = styled.p`
  font-weight: ${fontWeights.bold};
  margin-bottom: ${spacing.half};
`;

export const InboxContentSubtitle = styled.p`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  margin-bottom: 0;
  max-height: ${pxToRem(60)};
  overflow: hidden;
  padding-bottom: 0;
`;

export const InboxContentIcon = styled.img`
  border-radius: ${spacing.quarter};
  height: ${pxToRem(60)};
  width: ${pxToRem(60)};
`;

export const Iframe = styled.iframe`
  border: none;
  pointer-events: none;
  position: absolute;
  background-color: ${colors.white};
  left: ${pxToRem(50)};
  &.bottom {
    border-bottom-left-radius: ${pxToRem(16)};
    border-bottom-right-radius: ${pxToRem(16)};
    height: ${({ height }) => pxToRem(height)};
    bottom: ${pxToRem(106)};
  }
  &.center {
    top: calc(50% - ${pxToRem(50)});
    transform: translateY(-50%);
    height: ${({ height }) => pxToRem(height)};
  }
  &.full {
    top: ${pxToRem(25)};
    border-radius: ${pxToRem(16)};
  }
  &.top {
    top: ${pxToRem(25)};
    border-top-left-radius: ${pxToRem(16)};
    border-top-right-radius: ${pxToRem(16)};
    height: ${({ height }) => pxToRem(height)};
  }
`;
